<template>
    <layouts-header></layouts-header>

    <cage-breadcrumb :title="title" :text="text" :text1="text1" />

    <cage-tabset></cage-tabset>

    <!-- Page Content -->
    <div class="content book-cage">
        <div class="container">
            <section class="card mb-40">
                <div class="text-center mb-40">
                    <h3 class="mb-1">Order Confirmation</h3>
                    <p class="sub-title mb-0">Thank you for your order! We're excited to fulfill it with care and
                        efficiency.</p>
                </div>
                <div class="master-academy dull-whitesmoke-bg card">
                    <div class="row d-flex align-items-center justify-content-center">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                            <div class="d-sm-flex justify-content-start align-items-center">
                                <a href="javascript:void(0);"><img class="corner-radius-10"
                                        src="@/assets/img/master-academy.png" alt="Venue"></a>
                                <div class="info">
                                    <div class="d-flex justify-content-start align-items-center mb-3">
                                        <span
                                            class="text-white dark-yellow-bg color-white me-2 d-flex justify-content-center align-items-center">4.5</span>
                                        <span>300 Reviews</span>
                                    </div>
                                    <h3 class="mb-2">Manchester Academy</h3>
                                    <p>Manchester Academy: Where dreams meet excellence in sports education and training.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-6">
                            <ul class="d-sm-flex align-items-center justify-content-evenly">
                                <li>
                                    <h3 class="d-inline-block">$150</h3><span>/hr</span>
                                    <p>up to 1 guests</p>
                                </li>
                                <li>
                                    <span><i class="feather-plus"></i></span>
                                </li>
                                <li>
                                    <h3 class="d-inline-block">$5</h3><span>/hr</span>
                                    <p>each additional guest <br>up to 4 guests max</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <section class="card booking-order-confirmation">
                <h5 class="mb-3">Booking Details</h5>
                <ul class="booking-info d-lg-flex justify-content-between align-items-center">
                    <li>
                        <h6>Court Name</h6>
                        <p>Standard Synthetic Court 1</p>
                    </li>
                    <li>
                        <h6>Appointment Date</h6>
                        <p>Mon, Jul 11</p>
                    </li>
                    <li>
                        <h6>Appointment Start time</h6>
                        <p>05:25 AM</p>
                    </li>
                    <li>
                        <h6>Appointment End time</h6>
                        <p>06:25 AM</p>
                    </li>
                    <li>
                        <h6>Additional Guests</h6>
                        <p>4</p>
                    </li>
                </ul>
                <h5 class="mb-3">Contact Information</h5>
                <ul class="contact-info d-lg-flex justify-content-start align-items-center">
                    <li>
                        <h6>Name</h6>
                        <p>Rodick Tramliar</p>
                    </li>
                    <li>
                        <h6>Contact Email Address</h6>
                        <p>contact@example.com</p>
                    </li>
                    <li>
                        <h6>Phone Number</h6>
                        <p>+1 56565 556558</p>
                    </li>
                </ul>
                <h5 class="mb-3">Payment Information</h5>
                <ul class="payment-info d-lg-flex justify-content-start align-items-center">
                    <li>
                        <h6>Cage Total</h6>
                        <p class="primary-text">($250 * 2 hours)</p>
                    </li>
                    <li>
                        <h6>Additional Guest total</h6>
                        <p class="primary-text">(4 * $10)</p>
                    </li>
                    <li>
                        <h6>Subtotal</h6>
                        <p class="primary-text">$300.00</p>
                    </li>
                </ul>
            </section>
            <div class="text-center btn-row">
                <router-link class="btn btn-primary me-3 btn-icon" to="/coaches/cage-details"><i
                        class="feather-arrow-left-circle me-1"></i> Back</router-link>
                <router-link class="btn btn-secondary btn-icon" to="/coaches/cage-personalinfo">Next <i
                        class="feather-arrow-right-circle ms-1"></i></router-link>
            </div>
        </div>
        <!-- /Container -->
    </div>
    <!-- /Page Content -->

    <layout-footer></layout-footer>
</template>

<script>
export default {
    data() {
        return {
            title: 'Book A Court',
            text: 'Home',
            text1: 'Book A Court',
        }
    },
}
</script>